import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { platformSdk } from './lib/platformSdk';
import './styles/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Render immediately rather than blocking on SDK init — Poki/CrazyGames show
// their own loading ad overlay in parallel, so this just signals the platform
// once init resolves (no-op on web/itch/fb builds).
void platformSdk.init().then(() => platformSdk.gameLoadingFinished());
